const guiColors = {
    'motion-primary': '#7fff72',
    'motion-primary-transparent': '#7fff72e6',
    'motion-tertiary': '#66cc5e',

    'looks-secondary': '#7fff72',
    'looks-transparent': '#7fff7259',
    'looks-light-transparent': '#7fff7226',
    'looks-secondary-dark': 'hsla(116, 100%, 68%, 1)',

    'extensions-primary': 'hsla(116, 100%, 68%, 1)',
    'extensions-tertiary': 'hsla(116, 60%, 50%, 1)',
    'extensions-transparent': 'hsla(116, 100%, 68%, 0.35)',
    'extensions-light': 'hsla(116, 80%, 85%, 1)',

    'drop-highlight': '#b3ffad'
};

const blockColors = {
    checkboxActiveBackground: '#7fff72',
    checkboxActiveBorder: '#66cc5e'
};

export {
    guiColors,
    blockColors
};
